export const STANDARD = 'standard'
export const EXPANDED = 'expanded'

export default [STANDARD, EXPANDED]
